
(function productDiscountBar() {
    let discountCodeCookie;
    let localCouponsCookie;
    let discountCodeText;
    let intervalId;
    let checkCount = 0;
    let $discountButton;
    const $productDiscountBar = document.querySelector('product-discount-bar');
    if (!$productDiscountBar) return;

    function init() {
        intervalId = setInterval(checkStackDiscounts, 250);
        document.addEventListener('stack-discounts-loaded', productDiscountBarInit);
    }

    function checkStackDiscounts() {
        if (StackDiscounts) {
            stopCheckStackDiscounts();
            document.dispatchEvent(new CustomEvent('stack-discounts-loaded'));
            return;
        }
        if (checkCount >= 8) {
            stopCheckStackDiscounts();
            return;
        }
        checkCount++;
    }

    function stopCheckStackDiscounts() {
        clearInterval(intervalId);
        // release our intervalId from the variable
        intervalId = null;
    }

    function productDiscountBarInit() {
        discountCodeCookie = StackDiscounts.getCookie('discount_code').toUpperCase();
        localCouponsCookie = StackDiscounts.getCookie('localcoupons').toUpperCase();
        $discountButton = document.querySelector('.js-discount-button');
        discountCodeText = $discountButton.dataset.discountCode.toUpperCase();

        if (discountCodeCookie === discountCodeText || localCouponsCookie === discountCodeText) {
            showOfferClaimed()
        }

        if ($discountButton) {
            $discountButton.addEventListener('click', applyDiscount);
        }

        document.addEventListener('one-click-discount-added', showOfferClaimed);
    }

    function applyDiscount(e) {
        const { discountCode } = e.target.dataset;
        if (discountCode === '') return;

        discountCodeCookie = StackDiscounts.getCookie('discount_code');
        localCouponsCookie = StackDiscounts.getCookie('localcoupons');

        if (discountCodeCookie === discountCodeText || localCouponsCookie === discountCodeText) return;

        window.StackDiscounts.coupons.push(discountCode);
        StackDiscounts.setCookie("discount_code", `${discountCode}`);
        StackDiscounts.validateCoupons()
        document.dispatchEvent(new CustomEvent('one-click-discount-added'));
    }


    function showOfferClaimed() {
        $discountButton.innerHTML = '<span>OFFER CLAIMED</span>';
    }

    init();
})();